import { ThirdPartyService } from "~/services/ThirdPartyService";
import { defineStore } from "pinia";
import type { ThirdPartyRegisterStep0 } from "~/models/ThirdPartyRegisterStep0";
import type { ThirdPartyLogin } from "~/models/ThirdPartyLogin";

export const useThirdPartyStore = defineStore("thirdParty", {
  state: () => {
    return {
      isLoading: false
    };
  },
  getters: {},
  actions: {
      async postData(thirdParty: ThirdPartyRegisterStep0): Promise<void> {
          this.isLoading = true;
          try {
              await ThirdPartyService.thirdPartyRegister(
                  thirdParty,
                  (isLoading) => {
                      this.isLoading = isLoading;
                  }
              );
          } catch (error) {
              console.error(error);
              throw error;
          } finally {
              this.isLoading = false;
          }
      },
      async postLoginData(thirdParty: ThirdPartyLogin): Promise<void> {
          this.isLoading = true;
          try {
              await ThirdPartyService.thirdPartyLogin(
                  thirdParty,
                  (isLoading) => {
                      this.isLoading = isLoading;
                  }
              );
          } catch (error) {
              console.error(error);
              throw error;
          } finally {
              this.isLoading = false;
          }
      }
  }
});
